import { Badge } from '@one-thd/sui-atomic-components';
import React from 'react';
import { IPHDeliveryTrackerBadge } from '../../../models/delivery-tracker';
import { isBopisOutOfStockRecoverable } from '../../order-details/util/FulfillmentStatus';
import { FeatureSwitches } from '../../../constants/feature-switches';

export const PHOrderBadge = ({
  deliveryTrackerData,
  fulfillmentGroup,
  fulfillmentType,
  preShip,
}: IPHDeliveryTrackerBadge) => {
  const status = fulfillmentGroup?.lineItems?.[0]?.statusDescription ?? '';
  const successStatuses = [
    'Being Processed',
    'Processed',
    'Shipped',
    'In-Transit',
    'Reserved',
    'Out for Delivery',
    'On Schedule',
  ];
  const isBopisOosRecoverable =
    FeatureSwitches.enableBopisOutOfStockRecoverability &&
    fulfillmentGroup &&
    (fulfillmentType === 'BuyOnlinePickupInStore' ||
      fulfillmentType === 'BOPIS') &&
    isBopisOutOfStockRecoverable(fulfillmentGroup);

  if (
    (fulfillmentType === 'InStorePurchase' ||
      fulfillmentType === 'unavailable' ||
      status === 'Canceled' ||
      status === 'Delivered' ||
      status === 'Complete' ||
      deliveryTrackerData?.status === 'DELIVERED' ||
      (!successStatuses.includes(status) && status !== 'See Order Details')) &&
    !isBopisOosRecoverable
  ) {
    return null;
  }

  const badgeColor = () => {
    if (
      status === 'See Order Details' ||
      deliveryTrackerData?.status === 'DELAYED' ||
      isBopisOosRecoverable
    )
      return 'warning';

    if (['On Schedule', 'Processed'].includes(status) || preShip)
      return 'primary';

    if (successStatuses.includes(status)) return 'success';

    return null;
  };

  return (
    <div
      style={{
        marginBottom: '16px',
      }}
    >
      <Badge
        variant="subtle"
        style={{ textTransform: 'capitalize', fontSize: '12px' }}
        size="base"
        color={badgeColor()}
      >
        {(() => {
          if (deliveryTrackerData?.status === 'DELAYED') {
            return 'Delayed';
          }
          if (
            preShip ||
            fulfillmentGroup?.lineItems?.[0]?.statusDescription ===
              'On Schedule'
          ) {
            return 'Processed';
          }
          if (
            fulfillmentGroup?.lineItems?.[0]?.statusDescription ===
            'Return Initiated'
          ) {
            return 'Initiated';
          }
          if (isBopisOosRecoverable) {
            return 'Options Available';
          }
          if (deliveryTrackerData !== undefined) {
            if ((deliveryTrackerData?.status ?? '') === 'OUT_FOR_DELIVERY') {
              return 'Out for Delivery';
            }
            return (deliveryTrackerData?.status ?? '')
              ?.split('_')
              ?.map(
                (word) =>
                  word?.charAt(0).toUpperCase() + word?.slice(1).toLowerCase(),
              )
              ?.join(' ');
          }
          if (
            fulfillmentGroup?.lineItems?.[0]?.statusDescription === 'Shipped'
          ) {
            return 'Shipped';
          }
          if (
            fulfillmentGroup?.lineItems?.[0]?.statusDescription ===
            'Ready for Pickup'
          ) {
            return 'Ready for Pickup';
          }
          if (
            fulfillmentGroup?.lineItems?.[0]?.statusDescription === 'Delivered'
          ) {
            return 'Delivered';
          }
          return fulfillmentGroup?.lineItems?.[0]?.statusDescription;
        })()}
      </Badge>
    </div>
  );
};
